import styled from "styled-components";

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding-inline: 16px;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
`;

export const Content = styled.div`
  display: flex;
  gap: 4px;
  flex: 1;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  flex: 1;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: DM Sans;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: DM Sans;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;
